<template>
  <div class="modal fade" id="cuModal" tabindex="-1" role="dialog" aria-labelledby="cuModalLabel" aria-hidden="true">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="cuModalLabel">{{ modalContent.title }}</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="form-group">
            <label class="custom-label" for="name">Name</label>
            <input class="form-control" id="name"
              :class="form.errors.has('name') ? 'is-invalid' : ''"
              v-model="form.name" @keydown="form.errors.clear('name')"
            >
            <div class="invalid-feedback"
              v-if="form.errors.has('name')"
              v-text="form.errors.get('name')"
            />
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-primary"
            :disabled="form.isWorking()"
            @click="handleSubmit"
          >
            <span v-if="form.isWorking()">Checking Input...</span>
            <span v-else>{{ modalContent.submitText }}</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import createUpdateMixin from './../cu-modal-mixin'

  export default {
    mixins: [createUpdateMixin],
    data() {
      return {
      }
    },
  }
</script>



// WEBPACK FOOTER //
// resources/js/components/marketing_calendars/CuModal.vue